import { TAG_MODEL_KEY_POINTER } from 'models/daos/tag/constants'

const TAGS_DOMAIN = 'tags'
const TAGS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const TAGS_DOMAIN_MAP_KEY = TAG_MODEL_KEY_POINTER

export {
  TAGS_DOMAIN,
  TAGS_DOMAIN_MAP_KEY,
  TAGS_STATE
}
